<template>
  <text-setting-complex-update
    :showTextShadowSetting="true"
    :showOverflowSetting="false"
    :enableVerticalAlign="false"
    :showFontTypeSetting="extraConfig.showFontTypeSetting"
    :showTextAlignSetting="extraConfig.showTextAlignSetting"
    :hideHighLevelSetting="extraConfig.hideHighLevelSetting"
    :showLetterSpacingSetting="extraConfig.showLetterSpacingSetting"
    :disabled="{lineHeight: extraConfig.hideLineHeightSetting}"
    :showMoreBtn="extraConfig.showMoreBtn"
    :fontFamily.sync="configData.fontFamily"
    :fontSize.sync="configData.fontSize"
    :fontWeight.sync="configData.fontWeight"
    :fontStyle.sync="configData.fontStyle"
    :textDecoration.sync="configData.textDecoration"
    :lineHeight.sync="configData.lineHeight"
    :letterSpacing.sync="configData.letterSpacing"
    :writingMode.sync="configData.writingMode"
    :textAlign.sync="configData.textAlign"
    :lineHeightType.sync="configData.lineHeightType"
    :letterSpacingType.sync="configData.letterSpacingType"
    :isThemeColor.sync="configData.textIsThemeColor"
    :colorArr.sync="configData.fontColor"
    :activeNameColor.sync="configData.activeNameColor"
    :contentHasLimit="false"
    :contentHasLimitRadio="'words'"
    :textLimitWords="10"
    :textLimitLines="10"
    :verticalAlign.sync="configData.verticalAlign"
    :options="configData"
    :shadowBlur.sync="configData.shadowBlur"
    :shadowColor.sync="configData.shadowColor"
    :shadowH.sync="configData.shadowH"
    :shadowV.sync="configData.shadowV"
    :inMapSet="true"
    @updateAttrs="updateAttrs"
  />
</template>
<script>
import complexSetMixin from "./complexSetMixin.js"
import textSettingComplexUpdate from "@/modules/components/textSettingComplex_update.vue"
import { produce } from "immer";
export default {
  mixins: [complexSetMixin()],
  components: {
    textSettingComplexUpdate
  },
  props: {
    extraConfig: {
      type: Object,
      default: () => {
        return {
          showTextAlignSetting: true,
          hideHighLevelSetting: false,
          showFontTypeSetting: true,
          showMoreBtn: true,
          hideLineHeightSetting: false,
          showLetterSpacingSetting: true
        }
      }
    }
  },
  methods: {
    updateAttrs(attrs) {
      this.configData = produce(this.configData, draft => {
        Object.entries(attrs).forEach(([key, value]) => {
          draft[key] = value
        })
      })
    }
  }
}
</script>